import { render } from "./WhiteLabelLayout.vue?vue&type=template&id=7f91c578"
import script from "./WhiteLabelLayout.vue?vue&type=script&lang=js"
export * from "./WhiteLabelLayout.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__